import React from 'react';
import { Anchor, useHoneycombTheme } from '@honeycomb/ui-core';
export function DirectionSwitcher(props) {
    // const [dir, setDir] = useState<Direction>('ltr');
    const { dir, toggleDirection } = useHoneycombTheme();
    return (React.createElement(Anchor, Object.assign({ button: true, onClick: () => toggleDirection === null || toggleDirection === void 0 ? void 0 : toggleDirection() }, props),
        "Switch to ",
        dir === 'ltr' ? 'RTL' : 'LTR'));
}
